/*  Goalie, Skater, Team Selectors
    Below encapsulates the reports for the Skaters/Goalies/Team pages with all of their related info including:
    - chartRestUrl << dunno why this is still here or what it was for originally
    - positions the report applies to << don't know why we have this since everything's either skater or goalie
    - reportType :: basic or advanced/enhanced
    - game/season :: an object describing:
    - - whether the report is available for the time frame
    - - all of the displayable columns
    - - columns to add/remove (i forgot) when running a report with aggregated data
    - - columns for the custom filters
    - - default sorting

    It is also the module used to get any data related to a report, such as the measures used for data columns

    This information is used in multiple places so we have this object to pass around instead of using state
*/
const getAllReportData = (config) => {
    if (window.location.pathname.includes('goalie')) {
        return config.goalieReportData;
    }
    if (window.location.pathname.includes('team')) {
        return config.teamReportData;
    }

    // If no report was applied, just default to skater
    return config.playerReportData;
};

const getReportDataForTimeFrame = (config, timeFrame) => {
    const allReports = getAllReportData(config);
    const simplifiedTimeFrame = timeFrame === 'game' ? 'game' : 'season';

    return Object.keys(allReports).reduce((obj, key) => {
        if (allReports[key][simplifiedTimeFrame]) {
            return { ...obj, [key]: allReports[key] };
        }
        return obj;
    }, {});
};

const getReportData = (config, reportName) => {
    const allReports = getAllReportData(config);
    return allReports[reportName];
};

const getTimeSpecificDataOnReport = (config, report) => {
    const fullReportData = getReportData(config, report.reportName);
    const seasonOrGame = report.timeFrame === 'game' ? 'game' : 'season';
    return fullReportData[seasonOrGame];
};

const getMeasuresForReport = (config, report, datasetColumns) => {
    const timeSpecificReportData = getTimeSpecificDataOnReport(config, report);

    // We will make sure that all displayItem columns are actually in of our dataset
    return timeSpecificReportData.displayItems.filter((item) => datasetColumns.includes(item));
};

const getReportType = (config, reportName) => {
    const allReports = getAllReportData(config);
    return allReports[reportName].reportType;
};

export default {
    getReportDataForTimeFrame,
    getReportData,
    getTimeSpecificDataOnReport,
    getMeasuresForReport,
    getReportType,
};
